var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTrashAction(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13 3.66663L12.5869 10.35C12.4813 12.0576 12.4285 12.9114 12.0005 13.5252C11.7889 13.8287 11.5165 14.0848 11.2005 14.2773C10.5614 14.6666 9.706 14.6666 7.99513 14.6666C6.28208 14.6666 5.42553 14.6666 4.78603 14.2766C4.46987 14.0838 4.19733 13.8272 3.98579 13.5232C3.55792 12.9084 3.5063 12.0534 3.40307 10.3434L3 3.66663",
    stroke: "currentColor",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M2 3.66671H14M10.7038 3.66671L10.2487 2.72786C9.9464 2.10421 9.7952 1.79239 9.53447 1.59791C9.47667 1.55477 9.4154 1.5164 9.35133 1.48317C9.0626 1.33337 8.71607 1.33337 8.023 1.33337C7.31253 1.33337 6.95733 1.33337 6.66379 1.48945C6.59873 1.52405 6.53665 1.56397 6.47819 1.60882C6.21443 1.81117 6.06709 2.13441 5.77241 2.78088L5.36861 3.66671",
    stroke: "currentColor",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M6.33301 11V7",
    stroke: "currentColor",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M9.66699 11V7",
    stroke: "currentColor",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTrashAction);
export default __webpack_public_path__ + "static/media/trash-action.4d41a958bca3f823fce593bfcc7c79cb.svg";
export { ForwardRef as ReactComponent };